import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@nike/podium';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger } from '@nike/podium';
const hasActionIcon = (items) => {
    return items.some((item) => {
        if (item.actionIcon)
            return true;
        if (item.group)
            return hasActionIcon(item.group);
        if (item.sub)
            return hasActionIcon(item.sub);
        return false;
    });
};
const DropdownMenuWrapper = ({ menu, children, onCloseRequest }) => {
    const navigate = useNavigate();
    const hasActions = hasActionIcon(menu);
    const [open, setOpen] = useState(false);
    const closeHandler = hasActions
        ? () => {
            setOpen(false);
            onCloseRequest?.();
        }
        : null;
    return (_jsxs(DropdownMenu, { open: open, onOpenChange: setOpen, children: [_jsx(DropdownMenuTrigger, { asChild: true, className: "cursor-pointer", children: children || _jsx(Button, { children: "Menu" }) }), _jsx(DropdownMenuContent, { className: "mr-5", children: renderMenu(menu, navigate, closeHandler) })] }));
};
/**
 * Helper to render menu recursively.
 * @param menuContentItems - Menu items to render
 * @param navigate - React Router navigate function
 * @param handleClose - Optional close handler for complex menus with actions
 */
const renderMenu = (menuContentItems, navigate, handleClose) => menuContentItems.map((item, idx) => {
    if (item.separator)
        return _jsx(DropdownMenuSeparator, {}, idx);
    if (item.group)
        return (_jsx(DropdownMenuGroup, { children: renderMenu(item.group, navigate, handleClose) }, idx));
    if (item.sub)
        return (_jsxs(DropdownMenuSub, { children: [_jsx(DropdownMenuSubTrigger, { children: item.label }), _jsx(DropdownMenuSubContent, { children: renderMenu(item.sub, navigate, handleClose) })] }, idx));
    return (_jsx(DropdownMenuItem, { id: item.id, disabled: item.disabled, "data-variant": item.destructive ? 'destructive' : undefined, "data-inset": item.inset ? 'true' : undefined, inset: item.inset, className: `cursor-pointer ${item.actionIcon ? 'group' : ''}`, onSelect: () => {
            if (item.onClick) {
                item.onClick(item.id);
                handleClose?.();
            }
            else if (item.url) {
                navigate(item.url);
                handleClose?.();
            }
        }, children: item.actionIcon ? (_jsxs("div", { className: "justify-between flex w-full cursor-pointer", children: [_jsxs("span", { children: [item.label, item.suffix && (_jsxs("span", { className: "ml-2 text-gray-500", children: ["(", item.suffix, ")"] }))] }), item.actionIcon && item.onAction && handleClose && (_jsx("button", { type: "button", name: "action-btn", className: "opacity-0 group-hover:opacity-50 hover:opacity-100 transition-opacity cursor-pointer bg-transparent border-none p-0 flex items-center justify-center", onClick: async (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleClose();
                        try {
                            await item.onAction?.(item.id);
                        }
                        catch (error) {
                            console.error('Action error:', error);
                        }
                    }, children: _jsx(item.actionIcon, { size: 14, color: "black" }) }))] })) : (_jsxs("span", { className: "cursor-pointer", children: [item.label, item.suffix && (_jsxs("span", { className: "ml-2 text-gray-500", children: ["(", item.suffix, ")"] })), item.shortcut && _jsx("span", { children: item.shortcut })] })) }, item.id || item.label || idx));
});
export default DropdownMenuWrapper;
